import { render, staticRenderFns } from "./QRGenerator.vue?vue&type=template&id=5334c3ff&scoped=true&"
import script from "./QRGenerator.vue?vue&type=script&lang=js&"
export * from "./QRGenerator.vue?vue&type=script&lang=js&"
import style0 from "./QRGenerator.vue?vue&type=style&index=0&id=5334c3ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334c3ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5334c3ff')) {
      api.createRecord('5334c3ff', component.options)
    } else {
      api.reload('5334c3ff', component.options)
    }
    module.hot.accept("./QRGenerator.vue?vue&type=template&id=5334c3ff&scoped=true&", function () {
      api.rerender('5334c3ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/components/QRGenerator.vue"
export default component.exports